import { render, staticRenderFns } from "./NeopassList.vue?vue&type=template&id=4d153204&"
import script from "./NeopassList.vue?vue&type=script&lang=js&"
export * from "./NeopassList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports